import { Box, Button, Container, Grid, Tab } from '@mui/material';
import { useState } from 'react'
import { useAppContext } from '../../../../libs/app-core/AppContext';
import { Toast } from '../../../../libs/app-core/Toast';
import { linear_content_style, linear_item, linear_v } from '../../../../libs/linear-layout/LinearLayout';
import Label from '../../../../libs/rhf-mui/ui/Label';
import AppBarTabs from '../../../components/AppBarTabs';
import TabPage from '../../../components/TabPage';
import { UniFunc } from '../../../dao/UniFunc';
import { SpwkToHisInfo } from '.././SpwkToHisInfo';
import UcGovRowDto from './UcGovRowDto';
import UcHisBasicDto from './UcHisBasicDto';
import UcHisRowDto from './UcHisRowDto';
import UcHisTestView from './UcHisTestView';

type Props = {
  /** 左側選單 Focus 的轉檔結果 */
  CurrInfo: SpwkToHisInfo | undefined;

  /* 篩選: 特作編號 (此轉檔結果，繼續篩選，只看到指定特作) */
  CurrUniFunc: UniFunc | null;
  infoList: SpwkToHisInfo[];
}

const UcHisDtoView = ({ CurrInfo, CurrUniFunc, infoList, ...props }: Props) => {

  const ctx = useAppContext();

  const [CurrTabIndex, set_CurrTabIndex] = useState("tab_JSON");


  const json = JSON.stringify(CurrInfo?.HisDto, null, 4);
  return (
    <Grid {...linear_v}>

      {/* 上方控制區 */}
      <Grid {...linear_item}>
        <Container >
          {render_Tabs()}
        </Container>
      </Grid>

      {/* 下方內容區 */}
      <Grid {...linear_item} flex={1} sx={{}}>
        {render_TabControl(infoList)}
      </Grid>

    </Grid>
  )

  function render_Tabs() {
    return (
      <Container  >
        <AppBarTabs AppBarTabIndex={CurrTabIndex} set_AppBarTabIndex={set_CurrTabIndex} is_light_bg={true}>
          <Tab label="JSON" value={"tab_JSON"} />
          <Tab label="問卷基礎" value={"tab_問卷基礎"} />
          <Tab label="問卷明細" value={"tab_問卷明細"} />
          <Tab label="問卷申報" value={"tab_問卷申報"} />
          <Tab label="問卷UI基礎" value={"tab_問卷UI基礎"} />
        </AppBarTabs>
      </Container>
    );
  }

  function render_TabControl(infoList: SpwkToHisInfo[]) {
    return (
      <Box style={linear_content_style} sx={{ height: "100%", bgcolor: "" }}>
        <TabPage tab_key={"tab_Table"} curr_tab={CurrTabIndex} sx={{ bgcolor: "", height: "100%", overflow: 'hidden' }}>
          <Box sx={{ height: "100%", bgcolor: "" }}>
          </Box>
        </TabPage>

        <TabPage tab_key={"tab_JSON"} curr_tab={CurrTabIndex} >
          <Container >
            <Button variant='contained' sx={{ m: 2 }} onClick={() => { navigator.clipboard.writeText(json); Toast.Show(ctx, "已複製到剪貼簿") }}>複製JSON</Button>
            <br />
            <Label>{json}</Label>
          </Container>
        </TabPage>

        <TabPage tab_key={"tab_問卷基礎"} curr_tab={CurrTabIndex} sx={{ bgcolor: "", height: "100%", overflow: 'hidden' }}>
          <Box sx={{ height: "100%", bgcolor: "" }}>
            <UcHisBasicDto CurrInfo={CurrInfo} CurrUniFunc={CurrUniFunc} />
          </Box>
        </TabPage>

        <TabPage tab_key={"tab_問卷明細"} curr_tab={CurrTabIndex} sx={{ bgcolor: "", height: "100%", overflow: 'hidden' }}>
          <Box sx={{ height: "100%", bgcolor: "" }}>
            <UcHisRowDto CurrInfo={CurrInfo} CurrUniFunc={CurrUniFunc} />
          </Box>
        </TabPage>

        <TabPage tab_key={"tab_問卷申報"} curr_tab={CurrTabIndex} sx={{ bgcolor: "", height: "100%", overflow: 'hidden' }}>
          <Box sx={{ height: "100%", bgcolor: "" }}>
            <UcGovRowDto CurrInfo={CurrInfo} CurrUniFunc={CurrUniFunc} />
          </Box>
        </TabPage>
        <TabPage tab_key={"tab_問卷UI基礎"} curr_tab={CurrTabIndex} sx={{ bgcolor: "", height: "100%", overflow: 'hidden' }}>
          <Box sx={{ height: "100%", bgcolor: "" }}>
            <UcHisTestView CurrInfo={CurrInfo} CurrUniFunc={CurrUniFunc} infoList={infoList} />
          </Box>
        </TabPage>

      </Box>
    );
  }
}

export default UcHisDtoView